import { ConsoleInstrumentation, ErrorsInstrumentation, SessionInstrumentation, WebVitalsInstrumentation, } from '../instrumentations';
export function getWebInstrumentations(options = {}) {
    const instrumentations = [
        new ErrorsInstrumentation(),
        new WebVitalsInstrumentation(),
        new SessionInstrumentation(),
    ];
    if (options.captureConsole !== false) {
        instrumentations.push(new ConsoleInstrumentation({
            disabledLevels: options.captureConsoleDisabledLevels,
        }));
    }
    return instrumentations;
}
//# sourceMappingURL=getWebInstrumentations.js.map